<template>
    <div class="container">
        <br />
        <h1>Loading...</h1>
    </div>
</template>

<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/queries-vue-component";

    @Component({
        watch: {
            startupDetails: 'startupDetailsChanged'
        }
    })
    export default class StartupPage extends mixins(PageBase, VuePageQueries) {
        mounted() {
            this.runStartupDetailsQueryV1();
        }

        get startupDetails() { return this.model?.StartupDetails; }

        //@Watch('startupDetails')
        startupDetailsChanged(startupDetails) {
            if (startupDetails.Url) {
                location.href = startupDetails.Url;
            }
        }
    }
</script>